module.exports = __webpack_public_path__ + "img/avatar7.1fcc322c.png";